import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
Vue.use(VueRouter)
import { getType } from '@/util/auth'
export const constantRoutes = [
  {
    path: '/licenseManager',
    component: Layout,
    meta: { title: 'personInfo', icon: 'guide', noCache: true },
    children: [
      {
        path: '/licenseManager',
        meta: { title: 'accountManager', icon: 'guide', noCache: true },
        component: resolve => require(['../views/licenseManager.vue'], resolve)
      }
    ]
  },
  {
    path: '/modifyInfo',
    component: Layout,
    meta: { title: 'personInfo', icon: 'guide', noCache: true },
    children: [
      {
        path: '/modifyInfo',
        meta: { title: 'personInfo', icon: 'guide', noCache: true },
        component: resolve => require(['../views/modifyInfo.vue'], resolve)
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: resolve => require(['../views/login.vue'], resolve)
  },
  {
    path: '/resiger',
    name: 'resiger',
    hidden: true,
    component: resolve => require(['../views/resiger.vue'], resolve)
  },
  {
    path: '/forgetPwd',
    name: 'forgetPwd',
    hidden: true,
    component: resolve => require(['../views/forgetPwd.vue'], resolve)
  },
  {
    path: '/emailActive',
    name: 'emailActive',
    hidden: true,
    component: resolve => require(['../views/emailActive.vue'], resolve)
  },
  {
    path: '/registerSuccess',
    name: 'registerSuccess',
    hidden: true,
    component: resolve => require(['../views/registerSuccess.vue'], resolve)
  },
  {
    path: '/uploadFolder',
    component: Layout,
    hidden: !(getType() === '0' || getType() === 0),
    children: [
      {
        path: '/uploadFolder',
        meta: { title: 'fileUpload', icon: 'guide', noCache: true },
        component: resolve => require(['../views/uploadFolder.vue'], resolve)
      }
    ]
  },
  // {
  //   path: '/fileUpload',
  //   component: Layout,
  //   meta: { title: 'fileUpload', icon: 'guide', noCache: true, roles: 'dsim' },
  //   children: [
  //     {
  //       path: '/fileUpload',
  //       meta: { title: 'fileUpload', icon: 'guide', noCache: true, roles: 'dsim' },
  //       component: resolve => require(['../views/fileUpload.vue'], resolve)
  //     }
  //   ]
  // },
  {
    path: '*', // 重定向页面地址
    redirect: '/licenseManager'
  }
]
export const asyncRoutes = [

]
const createRouter = () => new VueRouter({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  mode: 'hash',
  routes: constantRoutes
})
const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js